module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/pond/pond-03_layoutphoto_02.png";